import { initializeSentry } from 'services/sentry'

initializeSentry()
